import { render, staticRenderFns } from "./tooling-form-action-buttons.component.vue?vue&type=template&id=25ca9b2d&scoped=true"
import script from "./tooling-form-action-buttons.component.vue?vue&type=script&lang=ts"
export * from "./tooling-form-action-buttons.component.vue?vue&type=script&lang=ts"
import style0 from "./tooling-form-action-buttons.component.vue?vue&type=style&index=0&id=25ca9b2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ca9b2d",
  null
  
)

export default component.exports